import { Component } from "../component"
import Swiper from "swiper"

export class ContactCarousel extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      swiperContainer: ".contact-carousel-swiper",
    }
  }

  initSwiper() {
    const { swiperContainer } = this.$ui

    if (!swiperContainer) return

    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024
    const slidesPerView = isTablet ? 1.08 : 1.11

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView,
      spaceBetween: 10,
      centeredSlides: true,
    })
  }

  created() {
    // Only initialize Swiper on mobile and tablet devices
    if (window.innerWidth < 1024) {
      this.initSwiper()
    }
  }
}
